export function SigningInView() {
  return (
    <p role="status" aria-live="polite">
      Signing in…
    </p>
  );
}
